/**
 * App-wide Material Tailwind theme overrides, deep-merged over the library defaults by ThemeProvider.
 *
 * Chips do not fade in. The default mount animation runs from opacity 0 to 1, and accessibility
 * scans that sample mid-fade read a chip's colours blended with the page behind it, failing
 * contrast that the resting colours pass. Rendering opaque from the first frame is also what
 * reduced-motion users expect.
 */
const materialTailwindTheme = {
  chip: {
    defaultProps: {
      animate: {
        mount: { opacity: 1 },
        unmount: { opacity: 1 },
      },
    },
  },
};

export default materialTailwindTheme;
